import { Routes, Route } from "react-router-dom";
import Layout from "../../components/Layout";
import Dashboard from "./components/Dashboard";
import PhysiciansRoutes from "./modules/physicians/physicians.routes";
import PatientsRoutes from "./modules/patients/patients.routes";
import ContractorRoutes from "./modules/contractors/contractors.routes";
import AppointmentRoutes from "./modules/appointments/appointment.routes";
import RequestRoutes from "./modules/requests/request.routes";
import ActivityPage from "./modules/activity/activity-page.component";
import Unverified from "./components/unverified-page.component";
import Deleted from "./components/deleted-page.component";
import InviteRoutes from "./modules/invites/invite.routes";
import PrescriptionRoutes from "./modules/prescriptions/prescription.routes";
import TransactionRoutes from "./modules/transactions/transaction.routes";
import AffiliatesRoutes from "./modules/affiliates/affiliates.routes";
import DiscountRoutes from "./modules/discounts/discount.routes";
import OrganizationsRoutes from "./modules/organizations/organizations.routes";
import { useSelector } from "react-redux";
import { selectUser } from "../auth/store/selectors";
import BasicDashboard from "./components/BasicDashboard";
import { useEffect } from "react";
import AgentRoutes from "./modules/agents/agents.routes";
import WithdrawalRequestRoutes from "./modules/withdrawals/withdrawal-request.routes";
import RefundsRoutes from "./modules/refunds/refunds.routes";
import AdminSettingsRoutes from "./modules/settings/settings.routes";
import FeedsRoutes from "./modules/feed/feed.routes";

export default function AdminRoutes() {
  const user = useSelector(selectUser);
  useEffect(() => {
    console.log(user);
  }, [user]);
  return (
    <Layout>
      <Routes>
        <Route path="/activity/*" element={<ActivityPage />} />
        <Route path="/appointments/*" element={<AppointmentRoutes />} />
        
        <Route path="/contractors/*" element={<ContractorRoutes />} />
        <Route path="/deleted-users" element={<Deleted />} />
        <Route path="/invites/*" element={<InviteRoutes />} />
        <Route path="/patients/*" element={<PatientsRoutes />} />
        <Route path="/prescriptions/*" element={<PrescriptionRoutes />} />
        <Route path="/physicians/*" element={<PhysiciansRoutes />} />
        <Route path="/requests/*" element={<RequestRoutes />} />
        <Route path="/transactions/*" element={<TransactionRoutes />} />
        <Route path="/unverified" element={<Unverified />} />
        <Route path="/affiliates/*" element={<AffiliatesRoutes />} />
        <Route path="/discounts/*" element={<DiscountRoutes />} />
        <Route path="/admin-orgs/*" element={<OrganizationsRoutes />} />
        <Route path="/withdrawal-requests/*" element={<WithdrawalRequestRoutes />} />
        <Route path="/refunds/*" element={<RefundsRoutes />} />
        <Route path="/feeds/*" element={<FeedsRoutes />} />


        {/* TODO changer */}{" "}
        {user?.Role === "super_admin" && (
          <>

            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/agents/*" element={<AgentRoutes />} />
            <Route path="/settings/*" element={<AdminSettingsRoutes />} />
            <Route path="*" element={<Dashboard />} />
          </>
        )}

{user?.Role !== "super_admin" && (
          <>

            <Route path="/dashboard" element={<BasicDashboard />} />
            <Route path="*" element={<BasicDashboard />} />
          </>
        )}
      </Routes>
    </Layout>
  );
}
